'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionOrGroupType = exports.OptionGroupType = exports.OptionType = exports.ValueType = exports.SingleValueType = undefined;

var _iconName = require('../utils/propTypes/iconName');

var _react = require('react');

var SingleValueType = exports.SingleValueType = _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.bool]);

var ValueType = exports.ValueType = _react.PropTypes.oneOfType([SingleValueType, _react.PropTypes.arrayOf(SingleValueType)]);

var OptionType = exports.OptionType = _react.PropTypes.shape({
  avatar: _react.PropTypes.node,
  badge: _react.PropTypes.object,
  buttonText: _react.PropTypes.node,
  disabled: _react.PropTypes.bool,
  dropdownClassName: _react.PropTypes.string,
  dropdownText: _react.PropTypes.node,
  icon: (0, _iconName.getIconNamePropType)(),
  imageUrl: _react.PropTypes.string,
  loading: _react.PropTypes.bool,
  tag: _react.PropTypes.object,
  tagUse: _react.PropTypes.string,
  text: _react.PropTypes.string,
  title: _react.PropTypes.string,
  value: SingleValueType
});

var OptionGroupType = exports.OptionGroupType = _react.PropTypes.shape({
  dropdownClassName: _react.PropTypes.string,
  emptyMessage: _react.PropTypes.string,
  options: _react.PropTypes.arrayOf(OptionType.isRequired).isRequired,
  text: _react.PropTypes.node,
  title: _react.PropTypes.string
});

var OptionOrGroupType = exports.OptionOrGroupType = _react.PropTypes.oneOfType([OptionGroupType, OptionType]);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/types/OptionTypes.js
// module id = 64
// module chunks = 0